// I18n?.admin.nothing_found

export var TouristAutocomplete = (function () {
  "use strict"

  // Конфигурация по умолчанию
  var defaultConfig = {
    minSearchLength: 3,
    perPage: 5,
    searchUrl: null,
    fieldMapping: {
      surname: "last_name",
      name: "first_name",
      passport_nr: "passport_nr",
      email: "email",
      telephone: "telephone",
      idn: "idno",
      birth_date: "date_birth",
    },
    searchableFields: ["surname", "name", "passport_nr", "email", "telephone", "idn"],
    // Селекторы
    selectors: {
      touristForm: ".tourist-info",
      suggestionItem: ".passenger-suggestion-item",
      suggestions: ".passenger-suggestions",
      loadMore: ".passenger-load-more",
      noResults: ".passenger-no-results",
    },
    // Колбеки
    onSelect: null,
    formatPassenger: null,
  }

  var searchTimeout
  var searchCache = new Map()
  var config = {}

  // Приватные методы
  function getTouristFormId($touristInfo) {
    return "tourist_" + $touristInfo.index()
  }

  function getInputId($input) {
    var fieldName = $input.attr("name")
    var touristIndex = $input.closest(config.selectors.touristForm).index()
    return fieldName + "_" + touristIndex
  }

  function getSearchParams($touristInfo) {
    var params = {}

    config.searchableFields.forEach(function (fieldName) {
      var $field = $touristInfo.find('input[name*="[' + fieldName + ']"]')

      if ($field.length === 0) {
        return
      }

      var value = $field.val()

      if (!value) {
        return
      }

      var trimmedValue = value.trim()

      if (trimmedValue.length >= config.minSearchLength) {
        var apiFieldName = config.fieldMapping[fieldName]
        params[apiFieldName] = trimmedValue
      }
    })

    return params
  }

  function closeAllSuggestions() {
    $(config.selectors.suggestions).remove()
    $(config.selectors.touristForm).removeClass("autocomplete-active")
    $(".client_list, table").css("overflow", "")
  }

  function formatDate(dateString) {
    if (!dateString) return ""

    var date = new Date(dateString)
    if (isNaN(date.getTime())) return dateString

    var day = String(date.getDate()).padStart(2, "0")
    var month = String(date.getMonth() + 1).padStart(2, "0")
    var year = date.getFullYear()

    return day + "." + month + "." + year
  }

  function formatTouristData(tourist) {
    if (config.formatPassenger) {
      return config.formatPassenger(tourist)
    }
    // Фо рматирование по умолчанию
    return {
      id: tourist.id,
      category_client_id: tourist.gender,
      gender: tourist.gender,
      surname: tourist.last_name || "",
      name: tourist.first_name || "",
      birth_date: formatDate(tourist.date_birth),
      passport_nr: tourist.passport_nr || "",
      passport_expiration_date: formatDate(tourist.passport_expiration),
      idn: tourist.idno || "",
      nationality: tourist.state ? tourist.state.name : "",
      telephone: tourist.telephone || "",
      email: tourist.email || "",
      language: "",
      is_blacklisted: tourist.is_blacklisted || false,
      booking_blocked: tourist.booking_blocked || false,
    }
  }

  function showLoadingIndicator($input) {
    $input.siblings(config.selectors.suggestions).remove()

    var $loading = $('<div class="passenger-suggestions"></div>')
    $loading.html(`<div class="passenger-no-results">${I18n?.admin.loading_dots}</div>`)
    $input.parent().append($loading)
    $loading.show()
  }

  function showNoResults($input) {
    $input.siblings(config.selectors.suggestions).remove()

    var $noResults = $('<div class="passenger-suggestions"></div>')
    $noResults.html(`<div class="passenger-no-results">${I18n?.admin.nothing_found}</div>`)
    $input.parent().append($noResults)
    $noResults.show()

    setTimeout(function () {
      $noResults.hide()
    }, 2000)
  }

  function searchPassengers($input, triggeredFieldName, $touristInfo, page) {
    page = page || 1
    var touristFormId = getTouristFormId($touristInfo)
    var searchParams = getSearchParams($touristInfo)

    if (Object.keys(searchParams).length === 0) {
      closeAllSuggestions()
      searchCache.delete(touristFormId)
      return
    }

    if (page === 1) {
      showLoadingIndicator($input)
    }

    var requestParams = $.extend({}, searchParams, {
      page: page,
      per_page: config.perPage,
    })

    console.log("Search request params:", requestParams)

    $.ajax({
      url: config.searchUrl,
      method: "GET",
      data: requestParams,
      dataType: "json",
      success: function (response) {
        if (response.success) {
          var passengers = response.data.map(formatTouristData)
          var pagination = response.pagination

          if (page === 1) {
            searchCache.set(touristFormId, {
              passengers: passengers,
              pagination: pagination,
              searchParams: searchParams,
            })
          } else {
            var cachedData = searchCache.get(touristFormId)
            if (cachedData) {
              cachedData.passengers = cachedData.passengers.concat(passengers)
              cachedData.pagination = pagination
              searchCache.set(touristFormId, cachedData)
            }
          }

          var currentCache = searchCache.get(touristFormId)
          if (currentCache) {
            showSuggestions(
              $input,
              currentCache.passengers,
              $touristInfo,
              currentCache.pagination,
              currentCache.searchParams
            )
          }
        } else {
          console.error("Search error:", response.error)
          showNoResults($input)
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX error:", error)
        showNoResults($input)
      },
    })
  }

  function showSuggestions($input, passengers, $touristInfo, pagination, searchParams) {
    $input.siblings(config.selectors.suggestions).remove()

    var $suggestions = $('<div class="passenger-suggestions"></div>')

    if (passengers.length === 0) {
      $suggestions.html(`<div class="passenger-no-results">${I18n?.admin.nothing_found}</div>`)
    } else {
      passengers.forEach(function (passenger) {
        var $item = $('<div class="passenger-suggestion-item"></div>')

        var name = (passenger.surname || "") + " " + (passenger.name || "")
        name = name.trim()
        var details = []

        if (passenger.birth_date) details.push(passenger.birth_date)
        if (passenger.idn) details.push(passenger.idn)
        if (passenger.passport_nr) details.push(passenger.passport_nr)

        var blacklistHtml = ""
        if (passenger.is_blacklisted) {
          blacklistHtml += '<span style="color:#dc3545;margin-right:4px;" title="' + (I18n?.tourists?.blacklist || 'Чёрный список') + '"><i class="fa fa-ban"></i></span>'
          if (passenger.booking_blocked) {
            blacklistHtml += '<span style="color:#dc3545;margin-right:4px;" title="' + (I18n?.tourists?.booking_blocked || 'Запрет на бронирование') + '"><i class="fa fa-lock"></i></span>'
          }
        }

        $item.html(blacklistHtml + "<small>" + name + "</small>" + "<small>" + details.join(" | ") + "</small>")

        $item.on("click", function (e) {
          e.preventDefault()
          e.stopPropagation()

          if (config.onSelect) {
            config.onSelect($touristInfo, passenger)
          } else {
            fillPassengerData($touristInfo, passenger)
          }

          closeAllSuggestions()

          var touristFormId = getTouristFormId($touristInfo)
          searchCache.delete(touristFormId)
        })

        $suggestions.append($item)
      })

      if (pagination && pagination.has_next) {
        var $loadMore = $(`<div class="passenger-load-more">${I18n?.admin.show_more}</div>`)

        $loadMore.on("click", function (e) {
          e.preventDefault()
          e.stopPropagation()

          if ($loadMore.hasClass("loading")) return

          $loadMore.addClass("loading")
          $loadMore.text("Загрузка...")

          var nextPage = pagination.current_page + 1
          searchPassengers($input, null, $touristInfo, nextPage)
        })

        $suggestions.append($loadMore)
      }
    }

    $input.parent().append($suggestions)
    $suggestions.show()
  }

  function fillPassengerData($touristInfo, passenger) {
    console.log("Filling passenger data:", passenger)

    if (passenger.category_client_id) {
      $touristInfo.find(".category_client_id").val(passenger.category_client_id)
    }
    if (passenger.surname) {
      $touristInfo.find(".surname").val(passenger.surname)
    }
    if (passenger.name) {
      $touristInfo.find(".name").val(passenger.name)
    }
    if (passenger.birth_date) {
      $touristInfo.find(".birth_date").val(passenger.birth_date)
    }
    if (passenger.idn) {
      $touristInfo.find(".idn").val(passenger.idn)
    }
    if (passenger.passport_nr) {
      $touristInfo.find(".passport_nr").val(passenger.passport_nr)
    }
    if (passenger.passport_expiration_date) {
      $touristInfo.find(".passport_expiration_date").val(passenger.passport_expiration_date)
    }

    if (passenger.nationality) {
      var $nationalitySelect = $touristInfo.find('select[name*="[nationality]"], .nationality')

      if ($nationalitySelect.length > 0 && $nationalitySelect.is("select")) {
        var optionFound = false

        $nationalitySelect.find("option").each(function () {
          var optionText = $(this).text().trim()
          if (optionText === passenger.nationality) {
            $nationalitySelect.val($(this).val())
            optionFound = true
            return false
          }
        })

        if (!optionFound) {
          $nationalitySelect.find("option").each(function () {
            var optionText = $(this).text().trim().toUpperCase()
            var searchText = passenger.nationality.toUpperCase()
            if (optionText.indexOf(searchText) !== -1 || searchText.indexOf(optionText) !== -1) {
              $nationalitySelect.val($(this).val())
              return false
            }
          })
        }
      } else {
        $touristInfo.find(".nationality").val(passenger.nationality)
      }
    }

    // ИСПРАВЛЕНО: добавлена проверка на существование и тип
    if (passenger.gender) {
      var $genderSelect = $touristInfo.find(
        'select[name*="[category_client_id]"], .category_client_id'
      )

      if ($genderSelect.length > 0 && $genderSelect.is("select")) {
        var optionFound = false
        // Преобразуем в строку и обрабатываем
        var genderText = String(passenger.gender).trim()

        $genderSelect.find("option").each(function () {
          var optionText = $(this).text().trim()
          var optionValue = String($(this).val()).trim()

          // Сравниваем и по тексту и по значению
          if (optionText === genderText || optionValue === genderText) {
            $genderSelect.val($(this).val())
            optionFound = true
            return false
          }
        })

        if (!optionFound) {
          var searchText = genderText.toUpperCase()

          $genderSelect.find("option").each(function () {
            var optionText = $(this).text().trim().toUpperCase()
            var optionValue = String($(this).val()).toUpperCase()

            if (
              optionText.indexOf(searchText) !== -1 ||
              searchText.indexOf(optionText) !== -1 ||
              optionValue === searchText
            ) {
              $genderSelect.val($(this).val())
              return false
            }
          })
        }
      } else {
        $touristInfo.find(".category_client_id").val(passenger.gender)
      }
    }

    if (passenger.telephone) {
      $touristInfo.find(".telephone").val(passenger.telephone)
    }
    if (passenger.email) {
      $touristInfo.find(".email").val(passenger.email)
    }
    if (passenger.language) {
      $touristInfo.find('select[name*="[language]"]').val(passenger.language)
    }

    $touristInfo.find(".surname, .name, .telephone, .idn, .birth_date").trigger("change")
  }

  function initEventHandlers() {
    // Обработчик input события
    config.searchableFields.forEach(function (fieldName) {
      $(document).on("input", 'input[name*="[' + fieldName + ']"]', function () {
        var $input = $(this)

        // ДОБАВЛЕНО: Пропускаем datepicker поля
        if ($input.hasClass("datepicker") || $input.attr("type") === "date") {
          return
        }

        var value = $input.val()
        var $touristInfo = $input.closest(config.selectors.touristForm)

        if ($touristInfo.length === 0) return

        clearTimeout(searchTimeout)
        closeAllSuggestions()

        if (!value || value.trim() === "") {
          var searchParams = getSearchParams($touristInfo)

          if (Object.keys(searchParams).length > 0) {
            $touristInfo.addClass("autocomplete-active")
            $touristInfo.find(".client_list, table, tbody, tr, td").css("overflow", "visible")

            searchTimeout = setTimeout(function () {
              searchPassengers($input, fieldName, $touristInfo)
            }, 300)
          }
          return
        }

        var trimmedValue = value.trim()

        if (trimmedValue.length < config.minSearchLength) {
          var searchParams = getSearchParams($touristInfo)

          if (Object.keys(searchParams).length > 0) {
            $touristInfo.addClass("autocomplete-active")
            $touristInfo.find(".client_list, table, tbody, tr, td").css("overflow", "visible")

            searchTimeout = setTimeout(function () {
              searchPassengers($input, fieldName, $touristInfo)
            }, 300)
          }
          return
        }

        $touristInfo.addClass("autocomplete-active")
        $touristInfo.find(".client_list, table, tbody, tr, td").css("overflow", "visible")

        searchTimeout = setTimeout(function () {
          searchPassengers($input, fieldName, $touristInfo)
        }, 300)
      })
    })

    // Обработчик focus события
    config.searchableFields.forEach(function (fieldName) {
      $(document).on("focus", 'input[name*="[' + fieldName + ']"]', function () {
        var $input = $(this)

        // ДОБАВЛЕНО: Пропускаем datepicker поля
        if ($input.hasClass("datepicker") || $input.attr("type") === "date") {
          return
        }

        var $touristInfo = $input.closest(config.selectors.touristForm)

        if ($touristInfo.length === 0) return

        closeAllSuggestions()

        var searchParams = getSearchParams($touristInfo)

        if (Object.keys(searchParams).length > 0) {
          var touristFormId = getTouristFormId($touristInfo)
          var cachedData = searchCache.get(touristFormId)

          if (cachedData && cachedData.passengers && cachedData.passengers.length > 0) {
            $touristInfo.addClass("autocomplete-active")
            $touristInfo.find(".client_list, table, tbody, tr, td").css("overflow", "visible")

            showSuggestions(
              $input,
              cachedData.passengers,
              $touristInfo,
              cachedData.pagination,
              cachedData.searchParams
            )
          } else {
            $touristInfo.addClass("autocomplete-active")
            $touristInfo.find(".client_list, table, tbody, tr, td").css("overflow", "visible")

            searchPassengers($input, fieldName, $touristInfo)
          }
        }
      })
    })

    // Закрываем при клике вне области
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".passenger-autocomplete").length) {
        closeAllSuggestions()
      }
    })

    // Закрываем при Escape
    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        closeAllSuggestions()
      }
    })
  }

  // Публичные методы
  return {
    init: function (options) {
      config = $.extend(true, {}, defaultConfig, options)

      if (!config.searchUrl) {
        console.error("TouristAutocomplete: searchUrl is required")
        return
      }

      // Оборачиваем все input заранее, чтобы не терять фокус при вводе
      config.searchableFields.forEach(function (fieldName) {
        $(config.selectors.touristForm)
          .find('input[name*="[' + fieldName + ']"]')
          .each(function () {
            var $input = $(this)
            if ($input.hasClass("datepicker") || $input.attr("type") === "date") return
            if (!$input.parent().hasClass("passenger-autocomplete")) {
              $input.wrap('<div class="passenger-autocomplete"></div>')
            }
          })
      })

      initEventHandlers()

      return this
    },

    destroy: function () {
      config.searchableFields.forEach(function (fieldName) {
        $(document).off("input", 'input[name*="[' + fieldName + ']"]')
        $(document).off("focus", 'input[name*="[' + fieldName + ']"]')
      })

      $(document).off("click")
      $(document).off("keydown")

      searchCache.clear()
    },

    clearCache: function () {
      searchCache.clear()
    },

    fillPassengerData: fillPassengerData,
  }
})()
